import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/seo/schemas";

const SITE_NAME = "Batch Cooking";
const DEFAULT_DESCRIPTION =
  "Planifiez votre batch cooking en une après-midi. L'IA compose 7 dîners équilibrés, génère votre liste de courses allée par allée et vous guide pas-à-pas en cuisine. Gratuit.";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-cover.jpg`;

interface SeoProps {
  title?: string;
  description?: string;
  canonicalPath?: string;
  ogImage?: string;
  noIndex?: boolean;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalPath = "/",
  ogImage = DEFAULT_OG_IMAGE,
  noIndex = false,
  jsonLd,
}: SeoProps) {
  const fullTitle = title
    ? `${title} — ${SITE_NAME}`
    : `${SITE_NAME} — Une après-midi. Sept dîners.`;
  const canonical = `${SITE_URL}${canonicalPath}`;
  const schemas = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas && (
        <script type="application/ld+json">{JSON.stringify(schemas)}</script>
      )}
    </Helmet>
  );
}
